import { render, staticRenderFns } from "./StatisticCardVerticalCompliance.vue?vue&type=template&id=6a3d35c7&"
import script from "./StatisticCardVerticalCompliance.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVerticalCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports